import router from '@/router'
import VueCookies from 'vue-cookies'
import {HTTP} from "@/main";
import axios from "axios"
import oplolocal from "@/config/oplolocal";
import * as https from "https";

const AXIOS = axios.create({
    baseURL: process.env.VUE_APP_API_URL,
    timeout: 0,
    withCredentials: false,
    httpsAgent: new https.Agent({
        rejectUnauthorized: false
    }),
});


export default {

    getUserInfo() {
        return HTTP.get('/session/user-info').then(res => {
            let response = res.data.responseData
            let data = {
                username: response.username,
                yphrMonada: response.yphrMonada,
                epitheto: response.epitheto,
                onoma: response.onoma,
                iduser: response.id_user,
                vathmos: response.vathmos,
                oplo: response.oplo,
                vathmosmenu: "",
                hasEfp: response.hasEfp,
                email: response.email,
                changeDate: response.changePassDate,
                monadaLek: response.monadaLek,
                taxisAddrVerified: response.taxisAddrVerified,
                kanonismoiAccess: response.kanonismoiAccess
            }

            if (response.role === "ROLE_USER") {
                data.efsa = response.efsa;
                data.mebelongs = response.mebelongs;
                data.thl = response.thl;
                data.isEmailVerified = response.emailVerified;
            } else {
                data.yphrKwd = response.yphrKwd;
                data.prosKwd = response.prosKwd;
                data.oplo = response.oplo;
                data.kinito = response.kinito;
                data.vathmos = response.vathmos;
                data.meeResponsible = response.meeResponsible;

                data.vathmosmenu = data.vathmos + "(" + oplolocal[data.oplo] + ")";
            }
            this.commit('set_role', response.role);
            this.commit("setUser", data)
            return data;
        })
    },

    getUserTaxInfo() {
        return HTTP.get(`/session/taxis-id`).then(res => {
            this.commit('setUserAFM', res.data.responseData.taxisId)
            return res.data.responseData
        })
    },

    logoutUser() {
        return AXIOS.get('api/auth/logout')
            .then(res => {
                router.push({name: 'logout'})
            })
            .catch(error => {
                console.log(error.toJSON)
            })
    },

    getStats() {
        return HTTP.get(`/admin/stats`)
    },
    loading() {
        var div = document.createElement('div');
        div.setAttribute('id', "loading_div");

        var img = document.createElement('img');
        img.setAttribute('id', "loading_img");

        img.src = '/files/loading.gif';
        img.style.cssText = 'border-radius:50%; z-index:999999; margin-top: 140px;';
        div.style.cssText = 'position: fixed; top: 0; left: 0; height: 100%; width: 100%; text-align: center; background-color: rgba(0,0,0,.4);z-index: 9999999; ';
        div.appendChild(img);
        document.body.appendChild(div);
        return true;
    },

    stop_loading () {
        var divdel = document.getElementById("loading_img");
        var imgdel = document.getElementById("loading_div");

        divdel.parentNode.removeChild(divdel);
        imgdel.parentNode.removeChild(imgdel);
    },

    export() {
        return HTTP.get(`/users/export-pdf`)
    },
    logout({commit}) {
        VueCookies.remove("token")
        commit('logout')
    },
    getMeMonadaItems: function () {
        return HTTP.get( "/admin/find-all-me")
    },
}